"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSlug = void 0;
const assertString_1 = require("./util/assertString");
const charsetRegex = /^[^\s-_](?!.*?[-_]{2,})[a-z0-9-\\][^\s]*[^-_\s]$/;
function isSlug(str) {
    (0, assertString_1.assertString)(str);
    return (charsetRegex.test(str));
}
exports.isSlug = isSlug;
